import React, { Component, useEffect, useState } from "react";
import blog_img from "../Images/courses_bg1.jpg";

function Blogs() {

  useEffect(() => {
    fetch('https://www.jsonblob.com/1105097882985578496')
  .then(response => console.log(response))

  // .then(response => response.json())
  // .then(data => console.log(data))
  // .catch(error => console.error(error));
  }, []);

  return (
    <div>
      <div class="blogs-container">
        <h1>Blogs</h1>
        <main class="blogs-grid">
          <article>
            <img src={blog_img} alt="" />
            <div class="blogs-text">
              <h3>
                How one Webflow user grew his consultancy with just a single
                person from $0-100K in 14 months?
              </h3>
              <p>
                Hey Friends today we will make a Responsive Layout Using Only
                CSS Grid. If you find this tutorial useful give it a like and
                Subscribe for more awesome web development content. Fell free to
                ask any question in comments.
              </p>
              <a href="/blogs/content">Read Full Article &rarr;</a>
            </div>
          </article>

          <article>
            <img src={blog_img} alt="" />
            <div class="blogs-text">
              <h3>
                How one Webflow user grew his consultancy with just a single
                person from $0-100K in 14 months?
              </h3>
              <p>
                Hey Friends today we will make a Responsive Layout Using Only
                CSS Grid. If you find this tutorial useful give it a like and
                Subscribe for more awesome web development content. Fell free to
                ask any question in comments.
              </p>
              <a href="/blogs/content">Read Full Article &rarr;</a>
            </div>
          </article>

          <article>
            <img src={blog_img} alt="" />
            <div class="blogs-text">
              <h3>
                How one Webflow user grew his consultancy with just a single
                person from $0-100K in 14 months?
              </h3>
              <p>
                Hey Friends today we will make a Responsive Layout Using Only
                CSS Grid. If you find this tutorial useful give it a like and
                Subscribe for more awesome web development content. Fell free to
                ask any question in comments.
              </p>
              <a href="/blogs/content">Read Full Article &rarr;</a>
            </div>
          </article>

          <article>
            <img src={blog_img} alt="" />
            <div class="blogs-text">
              <h3>
                How one Webflow user grew his consultancy with just a single
                person from $0-100K in 14 months?
              </h3>
              <p>
                Hey Friends today we will make a Responsive Layout Using Only
                CSS Grid. If you find this tutorial useful give it a like and
                Subscribe for more awesome web development content. Fell free to
                ask any question in comments.
              </p>
              <a href="/blogs/content">Read Full Article &rarr;</a>
            </div>
          </article>

          <article>
            <img src={blog_img} alt="" />
            <div class="blogs-text">
              <h3>
                How one Webflow user grew his consultancy with just a single
                person from $0-100K in 14 months?
              </h3>
              <p>
                Hey Friends today we will make a Responsive Layout Using Only
                CSS Grid. If you find this tutorial useful give it a like and
                Subscribe for more awesome web development content. Fell free to
                ask any question in comments.
              </p>
              <a href="/blogs/content">Read Full Article &rarr;</a>
            </div>
          </article>

          <article>
            <img src={blog_img} alt="" />
            <div class="blogs-text">
              <h3>
                How one Webflow user grew his consultancy with just a single
                person from $0-100K in 14 months?
              </h3>
              <p>
                Hey Friends today we will make a Responsive Layout Using Only
                CSS Grid. If you find this tutorial useful give it a like and
                Subscribe for more awesome web development content. Fell free to
                ask any question in comments.
              </p>
              <a href="/blogs/content">Read Full Article &rarr;</a>
            </div>
          </article>

          <article>
            <img src={blog_img} alt="" />
            <div class="blogs-text">
              <h3>
                How one Webflow user grew his consultancy with just a single
                person from $0-100K in 14 months?
              </h3>
              <p>
                Hey Friends today we will make a Responsive Layout Using Only
                CSS Grid. If you find this tutorial useful give it a like and
                Subscribe for more awesome web development content. Fell free to
                ask any question in comments.
              </p>
              <a href="/blogs/content">Read Full Article &rarr;</a>
            </div>
          </article>

          <article>
            <img src={blog_img} alt="" />
            <div class="blogs-text">
              <h3>
                How one Webflow user grew his consultancy with just a single
                person from $0-100K in 14 months?
              </h3>
              <p>
                Hey Friends today we will make a Responsive Layout Using Only
                CSS Grid. If you find this tutorial useful give it a like and
                Subscribe for more awesome web development content. Fell free to
                ask any question in comments.
              </p>
              <a href="/blogs/content">Read Full Article &rarr;</a>
            </div>
          </article>
        </main>
      </div>
    </div>
  );
}

export default Blogs;
